import { gql } from '@apollo/client';
import { USER_BASIC_FIELDS } from '../common';

export const AY_CONTACT_USER_FRAGMENT = gql`
  fragment AYContactUserInfo on AYContact {
    ${USER_BASIC_FIELDS}
  }
`;

export const USER_INFO_FRAGMENT = gql`
  ${AY_CONTACT_USER_FRAGMENT}
  fragment userInfo on User {
   ${USER_BASIC_FIELDS}
    companyName
    jobTitle
    token
    workPhone
    principalRole
    roles
    yearIndustry
    yearJoined
    language
    business {
      id
      name
    }
    businessType {
      id
      name
    }
    office {
      id
      name
    }
    subscriptions {
      features {
        id
        name
        featureType {
          id
          type
        }
      }
      product {
        name
      }
      fullAccess
      isActive
      productId
      accessData {
        marketId
        propertyId
        propertySetId
        submarketId
        companyId
        analyticsDashboardsId
      }
    }
    isProfileCompleted
    profileImageUrl
    preferences {
      propertyType
      propertyTypes
      marketIds
      termsAndConditionsDate
      termsAndConditionsVersion
      termsAndConditionsAccepted
      numberFormat
      weeklyScoopEmails
      trackedPeriod
      includeInStats
    }
    clientCompany {
      id
      name
      AYContactUser {
        ...AYContactUserInfo
      }
    }
    oktaUserId
  }
`;
